import { Pipe, PipeTransform } from '@angular/core';
import { ITimeBlockComponentItem } from '../types/time-block-component-item-types';
import { TimeBlockContentType } from '../types/time-block-types';
import {
  TimeBlockAbsenceModel,
  TimeBlockAppointmentModel,
  TimeBlockProjectModel,
} from '../../../../../core/models/timeblock/time-block.model';

@Pipe({
  name: 'timeBlockTitle',
  standalone: false,
})
export class TimeBlockTitlePipe implements PipeTransform {
  transform(timeBlockComponentItem: ITimeBlockComponentItem): unknown {
    const contentType = timeBlockComponentItem.timeBlockContentType;
    if (contentType === TimeBlockContentType.Project) {
      return (timeBlockComponentItem.timeBlockModel as TimeBlockProjectModel).task?.name ?? '';
    }

    if (contentType === TimeBlockContentType.Absence) {
      return (timeBlockComponentItem.timeBlockModel as TimeBlockAbsenceModel).reason.name;
    }

    if (contentType === TimeBlockContentType.Appointment) {
      return (timeBlockComponentItem.timeBlockModel as TimeBlockAppointmentModel).name;
    }

    return '';
  }
}
